import { tDispatch } from "../store";
import { tMaturityDate } from "../../interfaces/interfaces";
import { eBasicActionTypes } from "./basicTypes";
import { cStrike } from "../../classes/strike";

export const setBasicStep = (step: 0 | 1 | 2 | 3 | 4) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eBasicActionTypes.SET_CURRENT_STEP,
			payload: step
		})
	}
}

export const setBasicFToken = (token: string) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eBasicActionTypes.SET_CURRENT_F_TOKEN,
			payload: token
		})
	}
}

export const setBasicUToken = (token: string) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eBasicActionTypes.SET_CURRENT_U_TOKEN,
			payload: token
		})
	}
}

export const setBasicDirection = (direction: 'up' | 'down') => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eBasicActionTypes.SET_CURRENT_DIRECTION,
			payload: direction
		})
	}
}

export const setBasicMaturityDate = (maturity_date: tMaturityDate) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eBasicActionTypes.SET_CURRENT_MATURITY_DATE,
			payload: maturity_date
		})
	}
}

export const setBasicStrike = (strike: cStrike) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eBasicActionTypes.SET_CURRENT_STRIKE,
			payload: strike
		})
	}
}

export const stepBack = () => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eBasicActionTypes.STEP_BACK,
		})
	}
}